import { useMemo } from 'react';
import { useAhuDataContext } from '../../../context/ahuData';

const IsDisabled = (measurementKey: string) => {
    const { ahuTestDataEst } = useAhuDataContext();
    return useMemo(() => {
        if (ahuTestDataEst.measurements[measurementKey]?.statusNew !== "disabled") {
            return true
        } else {
            return false;
        }
    }, [ahuTestDataEst, measurementKey])
}
export default IsDisabled 
